// Strainer vertex schema — velocity-dependent Cv loss element. Dual elevation.
// A strainer is physically a fixed-Cv restriction (ΔP = (Q/Cv)²·SG), reusing the
// engine's fixed_flow_coefficient control-valve law with a FIXED Cv.

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema } from '../base/common';

const StrainerLossSchema = z.discriminatedUnion('mode', [
  z.object({ mode: z.literal('cv'), cv: z.number().positive() }),
  z.object({ mode: z.literal('k'), k: z.number().positive() }),
]);

export const StrainerVertexSchema = BaseVertexSchema.extend({
  type: z.literal('strainer'),
  // C++ never emits a strainer (Connect-only); elevations optional, mirroring fixed_loss.
  inlet_elevation: ValueWithUnitSchema.optional(),
  outlet_elevation: ValueWithUnitSchema.optional(),
  /** Loss spec: Cv (canonical) or K (Crane TP-410). REQUIRED — a strainer is never lossless. */
  loss: StrainerLossSchema,
  /** Static dirty/clean ΔP multiplier (>= 1). Default 1 (clean). ΔP_eff = factor·ΔP_clean. */
  fouling: z.object({ factor: z.number().min(1) }).optional(),
  /** Intended operating VOLUMETRIC flow (gpm, m3/s, …). Optional. Drives the design-time sizing check
   *  and the ΔP-equivalent export to fixed_loss. Absent → export of this strainer 422s (cannot linearize). */
  design_flow: ValueWithUnitSchema.optional(),
});

export type StrainerVertex = z.infer<typeof StrainerVertexSchema>;
